// extracted by mini-css-extract-plugin
export default {"main":"_8bd53345cc _0384407d0d b6683f1f68 _4c7195fc65","title":"_5825aeba13"};